<template>
  <div>

    <m-row>
      <m-col lg="6" style="padding-left: 0px;">
        <memlist-text-input
          v-if="domain"
          :title="title"
          size="sm"
          layout="vertical"
          :state="email_valid"
          v-model="value_model"
          validation_type="TEXT"
          :placeholder="domain_placeholder"
        />

        <memlist-select-input2
          v-else
          id="email-group" 
          :title="title" 
          v-model="value_model"
          :items="emails_list"
          :state="email_valid"
          layout="vertical"
          size="sm"
          validation_type="TEXT"
        />
        <p style="font-style: italic; color: #888888;">{{ valid_email_or_domains }}</p>
      </m-col>
      <m-col lg="6">
        <memlist-select-input2
          v-if="domain"
          id="email-group-select" 
          :title="$t('TEMPLATE.PREVIOUS_EMAILS')" 
          v-model="value_select"
          :items="emails_list"
          layout="vertical"
          size="sm"
          validation_type="TEXT"
          @input="selected_email_in_list"
        />
      </m-col>
    </m-row>
    
  </div>

  
  
</template>
<script>
import axios from 'axios';
import { validate_email } from '@/core/services/email';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

export default {
  name: 'EmailWithValidDomain',
  props: {
    value: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  },

  mixins: [ toasts ],
  watch: {
    value() {
      this.on_email_changed(this.value);
    }
  },
  emits: ['update:email'],
  components: {

  },

  data() {
    return {
      value_select: null,
      domain: null,
      emails_list: [],
      email_valid: false
    };
  },

  computed: {
    valid_email_or_domains() {
      if (this.domain) {
        return 'noreply@' + this.domain+', test@' + this.domain + ', admin@'+this.domain + ', etc...';
      }

      return '';
    },
    domain_placeholder() {
      return '...@' + this.domain;
    },
    value_model: {
      get() {
        return this.value
      },
      set(val) {
        this.on_email_changed(val);
      }
    },

  },

  async created() {
    await this.load_emails();
    this.on_email_changed(this.value);
  },

  methods: {

    selected_email_in_list(val) {
      this.$emit('update:email', val);
    },

    on_email_changed(value) {
      this.email_valid = this.validate_email(value);

      this.$emit('update:email', value);
    },

    validate_email(value) {
      if (!value) {
        return false;
      }

      return this.emails_list.map(i => i.value).includes(value) || (this.domain && value.indexOf(this.domain) >= 0);
    },

    async load_emails() {
      this.emails_list = [];
      try {
        const res = await axios.get(`/email/valid`);
        if (res.status === 200) {
          this.domain = res.data.find(i => i.domain && i.is_postmark_valid)?.domain || null;

          this.emails_list = res.data.filter(i => (!i.domain && !i.is_postmark_valid)).map(item => ({ value: item.email, text: item.email }));
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMPONENT.EMAIL_VALID_DOMAIN.UNABLE_LIST'));
        }
      } catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMPONENT.EMAIL_VALID_DOMAIN.UNABLE_LIST'));
      } 
    },
  }
};
</script>